import React, { Component } from "react";
import SimpleButton from "../../../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../../../modules/SimpleDataTable";
import Api from "../../../../../../Services/Api";
import { fetchDataAsync } from "../../../../../../Services/Utils";
import { HttpStatus } from "../../../../../common/Constants";
import {
  tableConfigAppointmentFUToday,
  tableConfigAppointmentOverdue,
  tableConfigProspekToday,
} from "./config";

// tab = prospek_today || appointment_today || appointment_overdue

export default class ReportProspek extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataTable: [],
      tableConfig: [],
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.kodeCabang?.value !== prevProps?.kodeCabang?.value) {
      this.fetchData();
    }
  }

  getConfig = () => {
    const { tab } = this.props;
    let config = null;

    if (tab === "prospek_today") {
      config = tableConfigProspekToday;
    } else if (tab === "appointment_today") {
      config = tableConfigAppointmentFUToday;
    } else if (tab === "appointment_overdue") {
      config = tableConfigAppointmentOverdue;
    }

    this.setState((prev) => ({
      ...prev,
      tableConfig: config,
    }));
  };

  componentDidMount() {
    this.getConfig();
    this.fetchData();
  }

  fetchData = async () => {
    const { onTriggerLoading, setError, tab, kodeCabang } = this.props;
    if (!kodeCabang?.value) return;
    let fn = null;
    let menuName = null;
    let payload = null;

    if (tab === "prospek_today") {
      fn = "getLaporanProspectStatistikToday";
      menuName = "Laporan Statistik Prospek Today";
      payload = {
        kodeCabang: kodeCabang?.value,
      };
    } else if (tab === "appointment_today") {
      fn = "getLaporanAppointmentProspect";
      menuName = "Laporan Appointment Follow Up Hari Ini";
      payload = {
        kodeCabang: kodeCabang?.value,
        appointmentType: tab === "appointment_today" ? "TODAY" : "OVERDUE", // OVERDUE or TODAY
        sortDirection: "asc",
        limit: 5,
        page: 1,
      };
    } else if (tab === "appointment_overdue") {
      fn = "getLaporanAppointmentProspect";
      menuName = "Laporan Appointment Overdue";
      payload = {
        kodeCabang: kodeCabang?.value,
        appointmentType: tab === "appointment_today" ? "TODAY" : "OVERDUE", // OVERDUE or TODAY
        sortDirection: "asc",
        limit: 5,
        page: 1,
      };
    }
    if (!fn) return;

    onTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_REPORT_DTO")[fn],
      menuName: menuName,
      setError: setError,
      args: payload,
    });
    onTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState({
        dataTable: tab === "prospek_today" ? [res.data.data] : res.data.data,
      });
    }
  };

  render() {
    const { dataTable, tableConfig } = this.state;
    return (
      <React.Fragment>
        <SimpleDataTable
          data={dataTable || []}
          columns={tableConfig}
          toCount={0}
          rowsPerPage={5}
          page={0}
          options={{ serverSide: false }}
          footerAdditionalButtons={
            <SimpleButton id="btn_print" text="CETAK" onClick={() => {}} />
          }
        />
      </React.Fragment>
    );
  }
}
